export default __webpack_public_path__ + "static/media/sick-days.e421a966.md";